import React from "react";
import Img from "gatsby-image";
import { Link } from "gatsby-plugin-intl";
import classnames from "classnames";
import cssClass from "./TeamMemberThumbnail.module.scss";

const TeamMemberThumbnail = ({
  image,
  name,
  title,
  featured,
  slug,
  clinicSlug,
}) => {
  const classes = classnames(cssClass.teamMember, {
    [cssClass.featured]: featured,
  });
  const path = `/${clinicSlug}/${slug}`;

  return (
    <div className={classes}>
      <Link to={path}>
        <Img className={cssClass.image} fluid={image.fluid} alt={image.title} />
      </Link>
      {/* TODO: vector outline */}
      <Link to={path}>
        <h3 className={cssClass.name}>{name}</h3>
      </Link>
      <p className={cssClass.title}>{title}</p>
    </div>
  );
};

export default TeamMemberThumbnail;
